var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main_container"}},[_c('PostContent'),(_vm.$config.site_name !== 'seven-sisters-studio')?_c('PostList',{attrs:{"needfixedtag":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }